import React from "react";
import { IPerson } from "../../../interfaces";
import ContactFrame from "./ContactFrame";

interface ProfessionalsSectionProps {
  professionals: IPerson[];
}

const Professionals: React.FC<ProfessionalsSectionProps> = ({
  professionals,
}) => {
  const predefinedTitles = ["Executive", "Partners", "Associates", "Counsel"] as const;
  type PredefinedTitle = typeof predefinedTitles[number];

  if (!professionals.length) {
    return null;
  } 

  const groupedProfessionals = professionals.reduce((acc, person) => {
    const title = person.title || "Others";
    const sectionTitle = predefinedTitles.includes(title as PredefinedTitle) ? title : "Others";
    
    if (!acc[sectionTitle]) {
      acc[sectionTitle] = [];
    }
    acc[sectionTitle].push(person);
    return acc;
  }, {} as Record<string, IPerson[]>);

  const orderedSections = [
    ...predefinedTitles.filter(title => groupedProfessionals[title]?.length > 0),
    ...(groupedProfessionals["Others"]?.length > 0 ? ["Others"] : [])
  ];
  
  return (
    <div className="flex gap-5 flex-col items-end lg:gap-[1.75rem] self-stretch overflow-hidden">
      <div className="flex flex-col items-start gap-[1.75rem] md:gap-8 w-full">
        {orderedSections.map((title) => (
          <div key={title} className="flex flex-col gap-6 w-full">
            <div className="flex items-center gap-4 self-stretch">
              <span className="font-decimal lg:text-lg lg:leading-5 font-medium text-Default">
                {title}
              </span>
              <hr className="flex h-0 justify-center flex-1" />
            </div>
            <div className="grid w-full items-start gap-5 self-stretch">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 p-0 gap-5 self-stretch">
                {groupedProfessionals[title].map((person: IPerson) => (
                  <ContactFrame key={person.id} person={person} />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Professionals;